import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import jQuery from 'jquery'

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import ContractorService from "../../services/contractor/contractor.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts.js';

import './modal/sendmail.css'

//import { Editor } from "@tinymce/tinymce-react";




import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  OnEventArgs,
  SlickgridReactInstance,
  OperatorType,
  MultipleSelectEditor,
  ColumnEditor,
  createDomElement,
  GridState,
  SlickDataView,
  FileType
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';

import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { Button, FormControl, InputAdornment, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Tooltip } from '@mui/material';
import { redirect, useLocation } from 'react-router-dom';
import { ReactNode, useState } from 'react';
import ContractorValidators from './validators';
import ContractorFormatters from './formatters';
import BorderSpinner from '../../components/Layout/spinner';
import ReactDOM from 'react-dom';
import contractorService from '../../services/contractor/contractor.service';
//import { Content, TDocumentDefinitions, PageBreak } from 'pdfmake/interfaces';
import { Pages } from '@mui/icons-material';
import EmailExportCSV from './export/email_to_excel';
import PhoneExportCSV from './export/phone_to_excel';
import ContractorTableExportCSV from './export/table_to_excel';
import emailService from '../../services/email/email.service';
import { cleanData } from 'jquery';


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const LOCAL_STORAGE_CONTRACTOR_EDIT_LIST = authService.getCurrentUser()?.shrt + '_crm-contractor-edit-list' 
const LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX = authService.getCurrentUser()?.shrt + '_crm-contractor-edit-index' 



const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};

async function getBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = reject
  })
}


class Contractor extends BaseGrid {
 


  wscols ;
  wscolsall ;
    

    title = 'Kontrahenci';
    subTitle = 'Zarządzanie kontrahentami'
    Validators;
    Formatters;
    queryParameters;
    own_contractor_groups;

    //mailContent : string; 

    lastApiCall ;

    selectedRows;

    addContractor;
    attachements;
    attachement_names;

    
   //props : BasicGridProps=
 constructor(props) {
    super(props);
   
    this.Validators = new ContractorValidators(this)
    this.Formatters = new ContractorFormatters(this)
    this.own_contractor_groups = []
    this.lastApiCall = new Date(0)
    this.addContractor=false
    this.attachements = []
    this.attachement_names = []
    

    this.queryParameters = new URLSearchParams(window.location.search)
    //this.group_name = queryParameters.get("group_name")
    //this.mailContent=''

    this.selectedRows = []
  
   /* for (let i = 0; i <= 25; i++) {
      this.custs.push({
        firstName: `firstname${i}`,
        lastName: `lastname${i}`,
        email: `mail${i}@mail.com`,
        address: `#${i}, block name, floor #${i} street name, city name, state name`,
        postcode: `${i}0000`
      });
    }
*/


   /* this.wscols = [
      { wch: Math.max(...this.custs.map((cust: { firstName: string | any[]; }) => cust.firstName.length)) },
      { wch: Math.max(...this.custs.map((cust: { lastName: string | any[]; }) => cust.lastName.length)) },
      { wch: Math.max(...this.custs.map((cust: { email: string | any[]; }) => cust.email.length)) },
      { wch: Math.max(...this.custs.map((cust: { address: string | any[]; }) => cust.address.length)) },
      {
        wch: Math.max(...this.custs.map((cust: { postcode: string | any[]; }) => cust.postcode.length)) + 3
      }
    ];
    */

    this.wscols = [
      { wch: 50 },
    
    ];

    this.wscolsall = [
      { wch: 50 },
    
    ];
    
 }

 beforeEditCard() {
  try{
    if (!this.state.incognito){
      let currentData = (this.reactGrid.slickGrid.getData()).getItems()
      let selectedID = (this.reactGrid.slickGrid.getData()).getAllSelectedFilteredIds()[0]
      let selectedIndex = (this.reactGrid.slickGrid.getData()).getIdxById(selectedID)
      localStorage.setItem(LOCAL_STORAGE_CONTRACTOR_EDIT_LIST, JSON.stringify(currentData))
      localStorage.setItem(LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX, JSON.stringify(selectedIndex))
    }
  }
  catch{

  }

}

 toArchive(){
  var selectedCount=0;
  var list='';
  var selectedData = [],
      selectedIndexes;
  var list='';
  var selectedCount=0;
  
  selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();
  if (selectedIndexes.length>0){
     selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();
   if (selectedIndexes.length>0){
    if (window.confirm('Ilość kontrahentów do archiwum: ' + selectedIndexes.length + '\nCzy potwierdzasz?')){
      var that = this  
      jQuery.each(selectedIndexes, function (index, value) {
          selectedCount++;
          var SelectedID = that.reactGrid.slickGrid.getDataItem(value).id;
          if (list==''){
            list= String(SelectedID);
          }else{
            list=list+',' + String(SelectedID);
          }
        });
        contractorService.toArchival(list).then( (resp) => {
          console.log(resp)
            alert('Poprawnie zarchiwizowano ' + resp + ' kontrahentów(a)')
            ///this.setState((state: State, props: BasicGridProps) => ({
            // ...state,
            //  alertInfo: 'Poprawnie zarchiwizowano ' + resp + ' kontrahentów',
            //}));
            window.location.reload()
         }).catch( error => {
          console.log(error)
         })
      }
    }
   }else{
      alert('Wybierz kontrahentów do archiwizacji');
   }
}

exportEmails(){

 
  
  
}

 setCoresspondenceAddresses(){
  var selectedCount=0;
  var list='';
  var selectedData = [],
      selectedIndexes;
  var list='';
  var selectedCount=0;
  
  selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();
  if (selectedIndexes.length>0){
      if (window.confirm('Ilość adresów do aktualizacji: '  + selectedIndexes.length + '\nCzy potwierdzasz?')){
        var that = this
        jQuery.each(selectedIndexes, function (index, value) {
          selectedCount++;
          var SelectedID = that.reactGrid.slickGrid.getDataItem(value).id;
          if (list==''){
            list= String(SelectedID);
          }else{
            list=list+',' + String(SelectedID);
          }
            });

       contractorService.setCorrAddresses(list).then( (resp) => {
        console.log(resp)
          this.setState((state, props) => ({
            ...state,
            alertInfo: 'Poprawnie zaktualizowano ' + resp + ' adresów(y)',
          }));
       }).catch( error => {
        console.log(error)
       })

     
      }
    }else{
      alert('Wybierz kontrahentów do aktualizacji adresów!');
    }
}

hideModal(){
  var modal = document.getElementById('sendEmailModal');
	if (modal){
    modal.style.display = "none";
  }
}



sendMailSubmit =  (e) => { 
	//console.log($('#mail_subject').val());
	
	var selectedCount=0;
	var list='';
	var selectedData = [],
  selectedIndexes;
	var list='';
	var selectedCount=0;
	list = 	jQuery('#mail_recipient').val() ;
	var tmp = list.split(';');
  var subject = 	jQuery('#mail_subject').val() ; 
//console.log(tmp);	
//console.log(window.tinyMCE.activeEditor.getContent())
//console.log('AAA')
//console.log(this.state.customEditor)
	selectedIndexes = tmp.length; //grid.getSelectedRows();
	if (selectedIndexes>0){
	  if (window.confirm('Ilość maili do wysłania: '  + selectedIndexes + '\nCzy potwierdzasz?')){
      //alert('Wysłano')
      var that= this
      
      //emailService.addMail(list, this.state.customEditor, subject ).then( async data => {
      emailService.addMail(list, window.tinyMCE.activeEditor.getContent(), subject ).then( async data => {
        var id = data;
       
        if (this.attachements && this.attachements.length > 0) {
          for (var x = 0; x < this.attachements.length; x++) {
            //console.log('AAAAA')
            //console.log(this.attachement_names[x])
            emailService.addAttachment(id, this.attachements[x], this.attachement_names[x]).then(data =>{
              alert('Mailing został zapisany!')
            }).catch(error => {
              alert('Błąd podczas zapisu załączników!')
            });
          }
        }else{
          alert('Mailing został zapisany!')
        }

      }).catch( error => {
        console.log(error)
        alert('Błąd podczas tworzenia mailingu!')
      })
      
    //  contractorService.savemailData().then( (resp) => {

    //  }).catch( error => {
    //    console.log(error)
    //  })
    }
  }
}


//handleEditorChange(e){
  //console.log('Content was updated:', e.target.getContent());
 // this.mailContent = e.target.getContent()
  //this.setState({content: e.target.getContent()});
//  alert('aaa')
//console.log(e.target.innerHTML)
//  this.setState((state, props) => ({
//    ...state,
//    customEditor: e.target.getContent(),
//  }));/
//}

sendMails(){
  var selectedCount=0;
  var list='';
  var selectedData = [],
      selectedIndexes;
  var list='';
  var selectedCount=0;
  //jQuery('#files').val('');
  //$('#mail_subject').val('');
  this.setState((state, props) => ({
    ...state,
    customEditor: '',
  }));

 // ($("#tinymce1") as Editor).editor.setContent("");
  
 var csvData = this.reactGrid.slickGrid.getSelectedRows().map((index)=> {return this.reactGrid.slickGrid.getDataItem(index).id});

 list = csvData.join(',')
  
  selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();

  //this.reactGrid.slickGrid.getSelectedRows().map((index : number)=> that.reactGrid.slickGrid.getDataItem(index))
  
 /* if (selectedIndexes.length>0){
    this.attachements=[]
    this.attachement_names=[]
       var that = this
      jQuery.each(selectedIndexes, function (index, value) {
        selectedCount++;
        var SelectedID = that.reactGrid.slickGrid.getDataItem(value).id;
        if (list==''){
          list= String(SelectedID);
        }else{
          list=list+',' + String(SelectedID);
        }
    });
  }
    */
 // alert(list)
 console.log("Selected Indexes: " + selectedIndexes)

  contractorService.getmails(list).then( (resp) => {
    //console.log(resp)
    console.log("Selected mails: " + resp)
    //$('#mail_recipient').val(resp);
					
		var modal = document.getElementById('sendEmailModal');

    if (modal){
		  modal.style.display = "block";
      jQuery('#mail_recipient').val(resp);
    }

  }).catch( error => {
    console.log(error)
  })

}

 printEnvelope(){
  var selectedCount=0;
  var list='';
  var selectedData = [],
      selectedIndexes;
  var list='';
  var selectedCount=0;
  
  selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();
  if (selectedIndexes.length>0){
       var that = this
       jQuery.each(selectedIndexes, function (index, value) {
        selectedCount++;
        var SelectedID = that.reactGrid.slickGrid.getDataItem(value).id;
        if (list==''){
          list= String(SelectedID);
        }else{
          list=list+',' + String(SelectedID);
        }
    });
    console.log(list)

    contractorService.getaddresses(list).then( (resp) => {
      console.log(resp)
      var data="";

              var arrayLength = resp.length;
              console.log(resp);
              var x;
              var contentAddresses = [];
              for (x = 0; x < resp.length; x++) {
                contentAddresses.push({text:'Expo Property BIS S.C.', pageNumbers:[1,2]});
                contentAddresses.push({text:'Chruściela 42A'});
                contentAddresses.push({text:'04-401 Warszawa'});
                contentAddresses.push({
                  table: {
                    widths: [300],
                    border: [false, false, false, false],
                    body: [
                      [{text:resp[x].name,alignment: 'center'}],
                      [{text:resp[x].street,alignment: 'center'}],
                      [{text:resp[x].city,alignment: 'center'}, ],
                      
                    ],
                    
                  },
                  pageNumber:x+1,
                  absolutePosition: {x: 280, y: 180},
                  layout: 'noBorders',
                })	

                
                if ( x < resp.length-1){
                  contentAddresses.push({
                    text:'',
                    pageBreak: 'after' , 
                     
                    }
                  )	
                }
              }
              
              
              var docDefinition  = {
                pageSize: {
                  width: 600,
                  height: 312
                },
                info : {
                  title : "Lista kopert",
                  author : "Expo Property BIS S.C.",
                },
                pageOrientation: 'landscape',
                
                content: contentAddresses,
                defaultStyle: {
                    //font: Object.keys(pdfMake.fonts)[0], // Any already loaded font
                },  
              };

              var win = window.open('about:blank', "window");

              pdfMake.fonts = {
                Roboto: {
                  normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                  bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                  italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                  bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
                }
             }
             // pdfMake.vfs = pdfFonts.pdfMake.vfs;

              const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            
              pdfDocGenerator.getDataUrl((dataUrl) => {
                var iframe = "<iframe width='100%' height='100%' src='"+dataUrl+"'></iframe>"
                win?.document.open();
                win?.document.write(iframe);
                win?.document.close();
              });
              
    }).catch( (error) => {
      console.log(error)
    })
      
   }else{
    alert('Wybierz kontrahentów');
   }
}


setSearchFilter() {
  if (this.reactGrid && ((localStorage[this.search_key] && localStorage[this.search_key]!=='')) || (localStorage[this.incognitoSearch_key] && localStorage[this.incognitoSearch_key]!=='')){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

shortnameFormatter = (row, cell, value, columnDef, dataContext) =>{
  var ownContractor = authService.isAdmin() 
  if (!ownContractor){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
          ownContractor = true;
            break;
         }  
       }
    }else{
      ownContractor = false;
    }
  }
  let s=""
  if ( dataContext.shortname !=null){
    if (ownContractor){
        //s ="<a class='slickRowLink' href='/standeditor/" + dataContext.id + "' >" + dataContext.name + "</a>";
        const fragment = new DocumentFragment();
        const li = document.createElement("a");
        li.innerHTML = dataContext.shortname
        li.href = '/contractors/card/' + dataContext.id 
        //li.target="_blank"
        onclick=this.beforeEditCard.bind(this)
        oncontextmenu=this.beforeEditCard.bind(this)
        fragment.append(li)
        return fragment
        //s ="<a class='slickRowLink' href='/contractors/card/" + dataContext.id + "' >" + dataContext.shortname + "</a>";
    }else{
       s=dataContext.shortname
    } 
  }
  return s;
};


nameFormatter = (row, cell, value, columnDef, dataContext) =>{
  var ownContractor = authService.isAdmin() 
  if (!ownContractor){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
          ownContractor = true;
            break;
         }  
       }
    }else{
      ownContractor = false;
    }
  }
  let s=""
  if ( dataContext.name !=null){
    if (ownContractor){
        const fragment = new DocumentFragment();
        const li = document.createElement("a");
        li.innerHTML = dataContext.name
        li.href = '/contractors/card/' + dataContext.id 
        //li.target="_blank"
        onclick=this.beforeEditCard.bind(this)
        oncontextmenu=this.beforeEditCard.bind(this)
        fragment.append(li)
        return fragment
      //s ="<a class='slickRowLink' href='/contractors/card/" + dataContext.id + "' >" + dataContext.name + "</a>";
    }else{
       s=dataContext.name
    } 
  }
  return s;
};

canDelete = (dataContext)  =>{
  var canDelete = authService.isAdmin() 
  if (!canDelete){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
           canDelete = true;
            break;
         }  
       }
    }else{
       canDelete = false;
    }
  }
  return canDelete;
} 
deleteFormatter =  (row, cell, value, columnDef, dataContext) => {
  
 if (this.canDelete(dataContext)){
   return createDomElement('i', { className: 'fa fa-trash pointer', ariaHidden: 'true' });
 }else{
   return ''
 }
};

reactGridReady(reactGrid) {
   super.reactGridReady(reactGrid);

   if (this.queryParameters){ 
      var group_name = this.queryParameters.get("group_name")
      if (group_name!=null && group_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'group_names_array', searchTerms: [group_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }
      var label_name = this.queryParameters.get("label")
      if (label_name!=null && label_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'labels_array', searchTerms: [label_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }
      var classification_name = this.queryParameters.get("classification")
      if (classification_name!=null && classification_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'classifications_array', searchTerms: [classification_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }
      var city_name = this.queryParameters.get("city")
      if (city_name!=null && city_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'city', searchTerms: [city_name.trimStart()] }
              ]); 	
              window.location.replace("/contractors")      
      }

      var contactdate = this.queryParameters.get("contactdate")
      if (contactdate!=null && contactdate=='today'){
        localStorage.removeItem(this.grid_currentconfig_key)
        var range: any[] = []
        var curr_date = new Date()
        var tomorrow = new Date();
        tomorrow.setDate(curr_date.getDate()+1);
        var curr_day = curr_date.getDate();
        var curr_month = curr_date.getMonth()+1;
        var curr_year = curr_date.getFullYear();

        var next_day = tomorrow.getDate();
        var next_month = tomorrow.getMonth()+1;
        var next_year = tomorrow.getFullYear();

        var start_date = curr_year.toString() +'-'+ curr_month.toString().padStart(2, '0') + '-' + curr_day.toString().padStart(2, '0') + " 00:00:00";
        var end_date = next_year.toString() + '-' + next_month.toString().padStart(2, '0') + '-' + next_day.toString().padStart(2, '0') + " 00:00:00";

        range.push(start_date)
        range.push(end_date)

        this.reactGrid.filterService.updateFilters([
              { columnId: 'contactdate', operator: "RangeInclusive",  searchTerms: range}
              ]); 	
              localStorage.removeItem(this.search_key);
              window.location.replace("/contractors")      
      }else{

         var all = this.queryParameters.get("all")
         if (all!=null && all=='true'){
          //console.log(this.search_key)
          localStorage.removeItem(this.grid_currentconfig_key) 
          localStorage.removeItem(this.search_key);
          this.reactGrid.filterService.updateFilters([]); 	
           window.location.replace("/contractors")  
         }

         var allsearch = this.queryParameters.get("allsearch")
         if (allsearch!=null && allsearch=='true'){
          //console.log(this.search_key)
          this.reactGrid.filterService.updateFilters([]); 	
           window.location.replace("/contractors")  
         }
      }

    }	       
}

onStorage = () => {
  this.setSearchFilter()
  window.dispatchEvent(new Event('serchcontractors'));
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
  window.addEventListener("resize",this.onResize)
  this.onResize()
  
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
  window.removeEventListener("resize",this.onResize)
};

onResize = () =>{
  setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
}


 componentDidUpdate() {
  window.tinymce.init({selector: '#tinymce1', 

    setup: (editor) => {
      editor.on("change", (e) => {
         this.setState((state, props) => ({
           ...state,
           customEditor: e.target.getContent(),
         }));

      });
    },

    height: 500, 
    //language: 'pl',
    //menubar: false,
    
    license_key: 'gpl',
    plugins: 'advlist autolink lists link image charmap preview anchor \
              searchreplace visualblocks code fullscreen \
                    insertdatetime media table code help wordcount',
    
    automatic_uploads: false,
    file_picker_types: 'image',
    image_description:true,
    paste_data_images: true,


    file_picker_callback: (callback, value, meta) => {

      var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
    
        input.onchange = async function(e) {
          var file = input.files? input.files[0] : null
          //var aaa=field_name;
          var reader = new FileReader();
          if (file) {
            var b64 = String(await getBase64(file))
            callback(b64, { text: 'My text' });
            }
          
          reader.onload = function (e) {
            var id = 'blobid' + (new Date()).getTime();
            
          };
        };
    
        input.click();	        
    },
    file_browser_callback : function myFileBrowser (field_name, url, type, win) {
        if (type=='image'){
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
    
        input.onchange = async function() {
          var aaa=field_name;
          var reader = new FileReader();
          reader.onload = function () {
            var id = 'blobid' + (new Date()).getTime();
          };
        };
    
        input.click();	
        }
        return false;
    },
    

    toolbar:
          'undo redo | formatselect | bold italic backcolor | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | help',

      
          
  }); 
}

componentDidMount() {

  //window.addEventListener('load', this.handleLoad);

  

  window.onload = () => {
   
   // window.tinymce.init({selector: '#tinymce1', plugins: 'lists link image table code help wordcount'}); 
  };

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();



  this.getcontractorlookups();
    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}


 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);
    
    if (presets){
      var new_sorters = presets.sorters.map((element) => {
        element.columnId = (element.columnId).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;

    
    }

    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets
    gridOptions.excelExportOptions = {
      exportWithFormatter: true,
       sanitizeDataExport: true ,
     }
    gridOptions.gridMenu.onCommand = (e, args) => {
           e.preventDefault()
                    if (args.command === 'best-fit') {
                      this.reactGrid.resizerService.resizeGrid()
                    }else if (args.command === 'export-excel'){
                      
                        this.excelExportService.exportToExcel({ filename: 'export',  sanitizeDataExport: true ,  format: FileType.xlsx });
                    }
                  }

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

//componentDidUpdate(PrevProps: any, prevState: State){
//  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){

 //     if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
        //alert(prevState.alertErrorMsg)
 //     }
 // }   
  
//}


  getGridDefinition() {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : authService.isAdmin(),
        excelExportOptions: {
          sanitizeDataExport: authService.isAdmin()
        },
        enableContextMenu:false,
       // enableTextExport: true,
      //  textExportOptions: {
      //    sanitizeDataExport: true
      //  },
        externalResources: authService.isAdmin? [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()] : [ this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item, _column, editCommand) => {
          var data = _item
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editContractorApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (this.state.incognito){
              if (localStorage[this.incognitoSearch_key] && localStorage[this.incognitoSearch_key]!=''){
                query=query + "&$search=" + localStorage[this.incognitoSearch_key].replace('&', 'i') 

                window.dispatchEvent(new Event('serchcontractors'));
                
              }
            }else{
              if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
                query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 

                window.dispatchEvent(new Event('serchcontractors'));
                
              }
            }
            var center = document.getElementById('center');
            if (!this.state.incognito){
              localStorage.setItem(this.query_key, query)
            }
          
            return this.getContractorApiCall(query)},
          postProcess: (response) => {
            if (new Date(response.metrics.startTime) > this.lastApiCall){
              this.lastApiCall = new Date(response.metrics.startTime)
              this.setState(
                (state: State) => ({ ...state, metrics: response.metrics }),
                () => this.postProcessCallback(response)
              );
            }
            this.displaySpinner(false);
          },
        } 
      }
    return tmp;
  }

  

  onCellValidationError(_e, args) {
    if (args.validationResults) {
      this.setState((state, props) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }

  

  getcontractorlookups(){
    return ContractorService.getcontractorlookups().then(response => {

          let tmp1 = []
          if ((response.data) && (Array.isArray(response.data))){
              tmp1  = response.data
          }
          this.setState((state) => ({
            ...state,
            lookupData : tmp1
          }),  () => {
            ContractorService.getOwnContractorGroups().then(response => { 
              if ((response) && (Array.isArray(response))){
                this.own_contractor_groups = response  
              }else{
                this.own_contractor_groups = []
              }
              this.defineGrid()
          

            }
            ).catch(
              () => {
                let tmp  = [];
                this.setState((state, props) => ({
                      ...state,
                      alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
                }));
                this.own_contractor_groups=[]
                return tmp;
              }
            )

           

            }
          );

     
    }
       
    ).catch(
      () => {
        let tmp  = [];
        this.setState((state, props) => ({
              ...state,
              alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
        }));
        return tmp;
      }
    )
  }



  getColumnDefinitions() {
    super.getColumnDefinitions()
    let tmp  = [];
    let data_contractorgroups= [];
    let data_contractorstates = [];
    let data_fairs  = [];
    let data_contractortrades  = [];
    let data_newmstate = [];
    let data_iis  = [];
    let data_classifications  = [];
    let data_ctypes  = [];
    let data_gtu  = [];
    //Adam To do
    this.state.lookupData?.forEach((item) => {
      if (item.name === 'contractorgroups'){
        data_contractorgroups = item.data; 
      } 
      else if (item.name === 'contractorstates'){
        data_contractorstates = item.data; 
      } 
      else if (item.name === 'fairs'){
        data_fairs = item.data; 
      }
      else if (item.name === 'contractortrades'){
        data_contractortrades = item.data; 
      }  
      else if (item.name === 'newmstates'){
        data_newmstate = item.data; 
      }  
      else if (item.name === 'iis'){
        data_iis = item.data; 
      }  
      else if (item.name === 'classifications'){
        data_classifications = item.data; 
      }  
      else if (item.name === 'contractortypes'){
        data_ctypes = item.data; 
      }  
      else if (item.name === 'gtu'){
        data_gtu = item.data; 
      }  
      
    });
      
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: this.deleteFormatter, // Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteContractorFormatter.bind(this) 
          },    
        }
      );

    
    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'shortname', name: 'Nazwa skrócona', field: 'shortname', sortable: true, filterable: true,
        type: FieldType.string,
        formatter:this.shortnameFormatter,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          validator : this.Validators.shortnameValidator,
          maxLength:3,
          compositeEditorFormOrder : 2,
          
        },
        hidden:false,
        minWidth:  100 
        
      },

      {
        id: 'name', name: 'Nazwa', field: 'name', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        formatter:this.nameFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          validator : this.Validators.nameValidator,
          maxLength:3,
          compositeEditorFormOrder : 3,
         
        },
        hidden:false,
        minWidth:100
           
      },
      {
        id: 'contactdate', name: 'Data kontaktu', field: 'contactdate', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        editor: {model: Editors.date,
          compositeEditorFormOrder : 4,
          editorOptions:{enableTime:true},
          massUpdate: authService.isAdmin(),
          
        },
        
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'group_names_array', name: 'Grupa', field: 'group_names_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.Formatters.groupFormatter,
        exportformatter: this.Formatters.exportgroupFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_contractorgroups},
        editor: {model: Editors.multipleSelect,
          collection: data_contractorgroups,
          massUpdate: authService.isAdmin(),
          compositeEditorFormOrder : 5,
        },
        onCellChange: this.ongroupNamesChange,
        queryField: 'group_names',
        minWidth:100
      },
      {
        id: 'contractor_state', name: 'Status', field: 'contractor_state', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_contractorstates, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_contractorstates,
          massUpdate: authService.isAdmin(),
          compositeEditorFormOrder : 6,
        },
        
        minWidth:100
      },
      {
        id: 'labels_array', name: 'Etykiety', field: 'labels_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.Formatters.labelFormatter,
        exportformatter: this.Formatters.exportLabelsFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_fairs},
        editor: {model: Editors.multipleSelect,
          collection: data_fairs,
          massUpdate: authService.isAdmin(),
          compositeEditorFormOrder : 7,
        },
        onCellChange: this.onLabelChange,
        queryField: 'labels',
        minWidth:100
      },
      {
        id: 'trade_name', name: 'Branża', field: 'trade_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_contractortrades, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_contractortrades,
          compositeEditorFormOrder : 8,
          massUpdate: authService.isAdmin(),
        },
        
        minWidth:100
      },
      
      {
        id: 'mail', name: 'E-mail z NL', field: 'mail', sortable: true, filterable: true,
        excludeFromColumnPicker: true,
        formatter: this.Formatters.mailFormatter,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.emailValidator,
          maxLength:100,
          compositeEditorFormOrder : 9
        },
        minWidth:100
      },
      {
        id: 'phone', name: 'Telefon', field: 'phone', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.phoneValidator,
          maxLength:100,
          compositeEditorFormOrder : 10
        },
        minWidth:100
      },
      {
        id: 'contractor_newmstate', name: 'Wysyłka Mailingu', field: 'contractor_newmstate', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_newmstate, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_newmstate,
          compositeEditorFormOrder : 11,
          massUpdate: authService.isAdmin(),
        },
        
        minWidth:100
      },
      {
        id: 'iis_name', name: 'Spis inwestycji', field: 'iis_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_iis, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_iis,
          compositeEditorFormOrder : 12,
          massUpdate: authService.isAdmin(),
        },
        
        minWidth:100
      },
      {
        id: 'classifications_array', name: 'Klasyfikacja', field: 'classifications_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.Formatters.classificationFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_classifications},
        editor: {model: Editors.multipleSelect,
          collection: data_classifications,
          compositeEditorFormOrder : 13,
          massUpdate: authService.isAdmin(),
        },
        onCellChange: this.onClassificationChange,
        queryField: 'classifications',
        minWidth:150
      },
      {
        id: 'unsub_eml', name: 'Email rezygnacja z NL', field: 'unsub_eml', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
      {
        id: 'inactive_eml', name: 'Email nieaktywny', field: 'inactive_eml', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
      {
        id: 'unsub_tel', name: 'Telefon rezygnacja z NL', field: 'unsub_tel', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 15,
        },
        
        minWidth:50
      },
      {
        id: 'nip', name: 'NIP', field: 'nip', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.nipValidator,
          maxLength:100,
          compositeEditorFormOrder : 1,
        },
        minWidth:100
      },
      {
        id: 'regon', name: 'REGON', field: 'regon', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.regonValidator,
          maxLength:100,
          compositeEditorFormOrder : 16
        },
        minWidth:100
      },
      {
        id: 'krs', name: 'KRS', field: 'krs', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.regonValidator,
          maxLength:100,
          compositeEditorFormOrder : 17
        },
        minWidth:100
      },
      {
        id: 'webpage', name: 'Strona WWW', field: 'webpage', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        formatter:this.Formatters.webpageFormatter,
        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 18,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'fax', name: 'FAX', field: 'fax', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.phoneValidator,
          maxLength:100,
          compositeEditorFormOrder : 19
        },
        minWidth:100
      },
      {
        id: 'postcode', name: 'Kod pocztowy', field: 'postcode', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.postcodeValidator,
          maxLength:20,
          compositeEditorFormOrder : 20
        },
        minWidth:100
      },
      {
        id: 'city', name: 'Miasto', field: 'city', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        formatter:this.Formatters.cityFormatter,
        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 21,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'street', name: 'Ulica', field: 'street', sortable: true, filterable: true,
        type: FieldType.string,  
        excludeFromColumnPicker: true,      
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 22,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'province', name: 'Województwo', field: 'province', sortable: true, filterable: true,
        type: FieldType.string, 
        excludeFromColumnPicker: true,       
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 23,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'country', name: 'Państwo', field: 'country', sortable: true, filterable: true,
        type: FieldType.string, 
        excludeFromColumnPicker: true,       
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 24,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },


      {
        id: 'cor_postcode', name: 'Kod pocztowy(adres kor.)', field: 'cor_postcode', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.text,
          validator : this.Validators.postcodeValidator,
          maxLength:25,
          compositeEditorFormOrder : 20
        },
        minWidth:100
      },
      {
        id: 'cor_city', name: 'Miasto (adres kor.)', field: 'cor_city', sortable: true, filterable: true,
        type: FieldType.string,
        formatter:this.Formatters.cityFormatter,
        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 26,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'cor_street', name: 'Ulica (adres kor.)', field: 'cor_street', sortable: true, filterable: true,
        type: FieldType.string,        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 27,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'cor_province', name: 'Województwo (adres kor.)', field: 'cor_province', sortable: true, filterable: true,
        type: FieldType.string,        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 28,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'cor_country', name: 'Państwo (adres kor.)', field: 'cor_country', sortable: true, filterable: true,
        type: FieldType.string,        
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          maxLength:100,
          compositeEditorFormOrder : 29,
          validator : this.Validators.maxlength100Validator,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'contractor_type', name: 'Typ', field: 'contractor_type', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_ctypes, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_ctypes,
          compositeEditorFormOrder : 30,
          massUpdate: authService.isAdmin(),
        },
        
        minWidth:100
      },
      {
        id: 'isperson', name: 'Osoba fizyczna', field: 'isperson', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 31,
        },
        
        minWidth:50
      },
      {
        id: 'sendmail', name: 'Przypomnienie', field: 'sendmail', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 32,
        },
        
        minWidth:50
      },
      {
        id: 'gtu_array', name: 'Grupa towarowa', field: 'gtu_array', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        editor: {model: Editors.multipleSelect,
          collection: data_gtu,
          compositeEditorFormOrder : 33,
          
          //collectionFilterBy: [{
          //  property: 'index',
          //  operator: OperatorType.equal,
          //  value: 
          //},] 
          
        },
        
        minWidth:100
      },
      {
        id: 'created', name: 'Data utworzenia', field: 'created', sortable: true, filterable: true,
        type: FieldType.dateTimeIso, // FieldType.string,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },
      {
        id: 'modified', name: 'Data edycji', field: 'modified', sortable: true, filterable: true,
        type: FieldType.dateTimeIso, //FieldType.string,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },

      {
        id: 'archival', name: 'Archiwalny', field: 'archival', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 34,
        },
        
        minWidth:50
      },
   
    );
    
    
    tmp = this.customizeHeaderMenu(tmp)

    return tmp
  }

  ongroupNamesChange(e, args){
    if (args.columnDef.field == 'group_names_array'){
        if (Array.isArray(args.dataContext['group_names_array']))
          args.dataContext['group_names'] = args.dataContext['group_names_array'].join(', ')
    }else{
      args.dataContext['group_names'] = ''
    }
  }
  onNIPChange(e, args){
    if (args.columnDef.field == 'nip'){
       // if (Array.isArray(args.dataContext['group_names_array']))
       //   args.dataContext['group_names'] = args.dataContext['group_names_array'].join(', ')
       console.log('DDDD')
       args.dataContext['name'] = 'AAAA' 
    }else{
       //args.dataContext['group_names'] = ''
    }
  }

  onClassificationChange(e, args){
    if (args.columnDef.field == 'classifications_array'){
        if (Array.isArray(args.dataContext['classifications_array']))
          args.dataContext['classifications'] = args.dataContext['classifications_array'].join(', ')
    }else{
      args.dataContext['classifications'] = ''
    }
  }

  onLabelChange(e, args){
    if (args.columnDef.field == 'labels_array'){
        if (Array.isArray(args.dataContext['labels_array']))
          args.dataContext['labels'] = args.dataContext['labels_array'].join(', ')
    }else{
      args.dataContext['labels'] = ''
    }
  }


  groupClicked(e, args){
    //alert('aaa')
    //console.log(e);
    //console.log(args);
  }

  deleteContractorFormatter(row, cell, value, column, dataContext, grid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Użytkownik:</div> <div>${dataContext.firstname} ${dataContext.shortname}</div></div>`;
  }

  getContractorApiCall(query) {
    return ContractorService.getcontractors(query)
  }
  editContractorApiCall(data) {  
    if ((data.contactdate == '') || ((data.contactdate == null))){
     // var tmpDate = data.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
     //data.contactdate = tmpDate[0] + 'T00:00:00'
     data.contactdate=0;
    }//else{
      //data.contactdate=0;
    //}

    ContractorService.editcontractor(data).then(
        
         () =>  {
          if (data.contactdate==0){
            data.contactdate=''
          }

          this.reactGrid.slickGrid.invalidate()
          
        }
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state, props) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }

      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowego kontrahenta';
          this.addContractor = true
          break;
        case 'clone':
          modalTitle = 'Kopiowanie kontrahenta - {{shortname}}';
          this.addContractor = false;
          break;
        case 'edit':
          this.addContractor = false;
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów';
            modalType = 'mass-selection';
            var selectedIDs = []
            selecttedcount.forEach(element => {
              selectedIDs.push(this.reactGrid.slickGrid.getDataItem(element).id)
            });
            //console.log('AAAAAA')
            //console.log(selecttedcount)
            //console.log('BBBBBBB')
            //console.log(selectedIDs)
          }else{
            this.addContractor = false;
            modalTitle = 'Edycja kontrahenta - (<span class="text-muted"></span><span class="text-primary">NIP: {{nip}}</span>)'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jednego kontrahenta do edycji!');
      }else{
        alert('Nie wybrano kontrahenta do edycji!');
      }
    }else{
   
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection, dataContext) => {
            this.addContractor = false;
            if (modalType == 'mass-selection'){
             console.log('AAA')
              console.log(formValues)
              //alert('mass-selection')
              this.displaySpinner(true);
              let tmp = {...formValues}

                if (tmp.contactdate == ''){
                  //var tmpDate = tmp.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
                  //tmp.contactdate = tmpDate[0] + 'T00:00:00'
                  tmp.contactdate=0;
                }//else{
                 // tmp.contactdate=0;
               // }
             
             
              if (selectedIDs && Array.isArray(selectedIDs) && selectedIDs.length>0){
                this.displaySpinner(true);
                ContractorService.massEdit(selectedIDs, tmp).then(
                  (data) => {
                    //this.reactGrid.filterService.updateFilters([])
                    
                   // this.setState((state: State, props: BasicGridProps) => ({
                   //   ...state,
                   //   alertInfo: "Zaktualizowano: " + data + " kontrahentów!"
                   // }));
                    this.displaySpinner(false);
                    alert("Zaktualizowano: " + data + " kontrahentów!")
                    window.location.reload() 
                  }
                  ).catch(
                    (error) => {
                      this.displaySpinner(false);
                      try{   
                        console.log(error)
                        if (error && error.response && error.response.data && error.response.data.detail){
                          this.setState((state, props) => ({
                            ...state,
                            alertError: "Błąd: " + error.response.data.detail
                          }));
                        }else{          
                          this.setState((state, props) => ({
                            ...state,
                            alertError: "Błąd podczas masowej edycji kontrahentów"
                          }));
                        }
                        
                      }catch{
            
                      }
                    }
                  )   
              }

              

            }else{
              if (_selection.gridRowIndexes.length===0){
                let tmp = {...formValues, ...dataContext, id:null}
                console.log(dataContext)
                console.log(formValues)
                if (tmp.contactdate == ''){
                  tmp.contactdate=0;
                  //var tmpDate = tmp.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
                  //tmp.contactdate = tmpDate[0] + 'T00:00:00'
                }//else{
                 // tmp.contactdate=0;
               // }

                ContractorService.addcontractor(tmp).then(
                  (data) => {
                    //this.reactGrid.filterService.updateFilters([])
                    if (data.contactdate==0){
                      data.contactdate=''
                    }
                    this.reactGrid.slickGrid.invalidate()
                    window.location.replace("/contractors/card/" + data.id)   
                    //console.log(data)
                  }
                  ).catch(
                    (error) => {
                      try{   
                        console.log(error)
                        if (error && error.response && error.response.data && error.response.data.detail){
                          this.setState((state, props) => ({
                            ...state,
                            alertError: "Błąd: " + error.response.data.detail
                          }));
                        }else{          
                          this.setState((state, props) => ({
                            ...state,
                            alertError: "Błąd podczas dodawania kontrahenta"
                          }));
                        }
                        
                        var tmp = this.reactGrid.slickGrid.getData().getItems()
                        tmp.splice(0,1);
                        
                        this.reactGrid.slickGrid.getData().setItems(tmp)
                      }catch{
            
                      }
                    }
                  )   
              }
          }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e, args) {
    this.addContractor = false;
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);
    if (metadata.columnDef.id === 'delete') {
      if (this.canDelete(metadata.dataContext)){
        if (window.confirm('Czy potwierdzasz usunięcie kontrahenta: ' + metadata.dataContext.shortname + '?')) {
          ContractorService.deletecontractor(metadata.dataContext.id).then(
            () => {
              this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

              this.setState((state, props) => ({
                ...state,
                alertInfo: `Usunięto: ${metadata.dataContext.shortname}`,
              }));
          }

          ).catch(
            () => {
              this.setState((state, props) => ({
                ...state,
                alertError: `Wystąpił problem przy usuwaniu kontrahenta: ${metadata.dataContext.shortname}`,
              }));
            }
          )
          
          
        }
      }
    }
  }

  checkItemIsEditable(dataContext, columnDef, grid) {
    const gridOptions = grid.getOptions();
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin() 
      if (!authService.isAdmin()){
        if (Object.keys(dataContext).length === 0){
          isEditable = true;
        }else{
          if (!this.addContractor){
            if ((dataContext?.archival == null) || (dataContext?.archival <=0)){
              if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
                  for (const group in dataContext?.group_names_array){
                    if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
                      isEditable = true;
                      break;
                    }  
                  }    
              }else{
                isEditable = false;
              }
            }else{
              isEditable = false;
            }
          }else{
            isEditable = true;
          }
        }
      }else{
        isEditable = true;
      } 
    }
    return isEditable;
  }

  handleonAddNewRow(_e, args) {
     //return true;
  }

  handleChangeGridConfig(event, child) {
    console.log(event.target.value)
    localStorage.setItem(this.grid_currentconfig_key, event.target.value)
    this.setState((state, props) => ({
      ...state,
      configuration_state: event.target.value
    }));

    if (event.target.value!='Domyślna'){

      var allEntries = localStorage.getItem(this.grid_config_key) ? JSON.parse(localStorage.getItem(this.grid_config_key)) : [];
      const found = allEntries.find((element) => element.label == event.target.value);

      console.log(found)
      localStorage[this.storage_key] = found.grid;
    }else{
      localStorage.removeItem(this.storage_key);

    }
    //this.setState(
    window.location.reload();
  }


  handleOnCompositeEditorChange(_e, args) {
    const columnDef = args.column;
    const formValues = args.formValues;
    if (columnDef.field === 'nip' && formValues.nip.length >= 10) {
          ContractorService.getExternalData(formValues.nip).then(response => {
          if (response.nip == formValues.nip){
            if (response.name != null) {this.compositeEditorInstance.changeFormValue('name', response.name);}
            if (response.shortname != null) {this.compositeEditorInstance.changeFormValue('shortname', response.shortname);}
            if (response.regon != null) {this.compositeEditorInstance.changeFormValue('regon', response.regon);}
            if (response.krs != null) {this.compositeEditorInstance.changeFormValue('krs', response.krs);}
            if (response.country != null) {this.compositeEditorInstance.changeFormValue('country', response.country);}
            if (response.city != null) {this.compositeEditorInstance.changeFormValue('city', response.city);}
            if (response.street != null) {this.compositeEditorInstance.changeFormValue('street', response.street);}
            if (response.postcode != null) {this.compositeEditorInstance.changeFormValue('postcode', response.postcode);}
            if (response.webpage != null) {this.compositeEditorInstance.changeFormValue('webpage', response.webpage);}
            if (response.province != null) {this.compositeEditorInstance.changeFormValue('province', response.province);}
            if (response.mail != null) {this.compositeEditorInstance.changeFormValue('mail', response.mail);}
            if (response.isperson != null) {this.compositeEditorInstance.changeFormValue('isperson', response.isperson);}

            if (response.cor_country != null) {this.compositeEditorInstance.changeFormValue('cor_country', response.cor_country);}
            if (response.cor_city != null) {this.compositeEditorInstance.changeFormValue('cor_city', response.cor_city);}
            if (response.cor_street != null) {this.compositeEditorInstance.changeFormValue('cor_street', response.cor_street);}
            if (response.cor_postcode != null) {this.compositeEditorInstance.changeFormValue('cor_postcode', response.cor_postcode);}
            if (response.cor_province != null) {this.compositeEditorInstance.changeFormValue('cor_province', response.cor_province);}



            if (response.name != null) {this.compositeEditorInstance.changeFormInputValue('name', response.name, true);}
            if (response.shortname != null) {this.compositeEditorInstance.changeFormInputValue('shortname', response.shortname, true);}
            if (response.regon != null) {this.compositeEditorInstance.changeFormInputValue('regon', response.regon, true);}
            if (response.krs != null) {this.compositeEditorInstance.changeFormInputValue('krs', response.krs, true);}
            if (response.country != null) {this.compositeEditorInstance.changeFormInputValue('country', response.country, true);}
            if (response.city != null) {this.compositeEditorInstance.changeFormInputValue('city', response.city, true);}
            if (response.street != null) {this.compositeEditorInstance.changeFormInputValue('street', response.street, true);}
            if (response.postcode != null) {this.compositeEditorInstance.changeFormInputValue('postcode', response.postcode, true);}
            if (response.webpage != null) {this.compositeEditorInstance.changeFormInputValue('webpage', response.webpage, true);}
            if (response.province != null) {this.compositeEditorInstance.changeFormInputValue('province', response.province, true);}
            if (response.mail != null) {this.compositeEditorInstance.changeFormInputValue('mail', response.mail, true);}
            if (response.isperson != null) {this.compositeEditorInstance.changeFormInputValue('isperson', response.isperson, true);}

            if (response.cor_country != null) {this.compositeEditorInstance.changeFormInputValue('cor_country', response.cor_country, true);}
            if (response.cor_city != null) {this.compositeEditorInstance.changeFormInputValue('cor_city', response.cor_city, true);}
            if (response.cor_street != null) {this.compositeEditorInstance.changeFormInputValue('cor_street', response.cor_street, true);}
            if (response.cor_postcode != null) {this.compositeEditorInstance.changeFormInputValue('cor_postcode', response.cor_postcode, true);}
            if (response.cor_province != null) {this.compositeEditorInstance.changeFormInputValue('cor_province', response.cor_province, true);}


          // console.log(this.compositeEditorInstance.formValues)

            
          
          }else{
            console.log('Not find in external sources')
          } 
                
       }).catch(
            (error) => {
              console.log(error)
    
            }
        );
          
    }
  }

  handleOnBeforeEditCell(e, args) {
    const { column, item, grid } = args;
    //column?.editor.collection = [];
    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }


  action(snackbarId){
    return(
    <>
       <Button  onClick={() => { closeSnackbar(snackbarId) }} variant="contained">Zamknij</Button>
      
    </>
    )
  }

  imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      var b64 = String(await getBase64(e.target.files[0]))
      this.attachements.push(b64)
      this.attachement_names.push(e.target.files[0].name)
    }
  };

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state, props) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state, props) => ({
        ...state,
        alertError: ''
      }));
    }
    //console.log(this.state.alertErrorMsg)
    if (this.state.alertErrorMsg.length > 0){
      for (const msg in this.state.alertErrorMsg){
        enqueueSnackbar(this.state.alertErrorMsg[msg], {action: this.action, variant: 'warning', preventDuplicate: true,  autoHideDuration:5000, persist: true})
      }
      this.setState((state, props) => ({
        ...state,
        alertErrorMsg: []
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state, props) => ({
        ...state,
        alertInfo: ''
      }));
    }

   
   
    
    const handleSaveConfigKeyDown = (e) => {
      if (e.key === 'Enter') {

            var val  = jQuery('#input_save_grid_config').val();
            console.log(val)
            if (val != ''){
              const gridState = this.reactGrid.gridStateService.getCurrentGridState();
        
              var allEntries = localStorage.getItem(this.grid_config_key) ? JSON.parse(localStorage.getItem(this.grid_config_key)) : [];
             // console.log(allEntries);
              var tmp = allEntries.find((element) => element.label==val)
              if (tmp){
                if (window.confirm("Istnieje już konfiguracja o podanej nazwie, czy chcesz ją nadpisać?")){
                  allEntries = allEntries.map((element) => element.label==val ? {...element, grid: JSON.stringify(gridState)} : {...element} ) 
                }
              }else{
                allEntries.push({label:val, grid: JSON.stringify(gridState)}); 
              }
             // console.log(allEntries);
              localStorage.setItem(this.grid_config_key, JSON.stringify(allEntries))
              //localStorage.setItem(LOCAL_STORAGE_SEARCH_INCOGNITO, val)
              window.location.reload();
            }
      
        
      }
    };
    
    //console.log(JSON.parse(localStorage[this.grid_config_key])) 

   // {localStorage[this.grid_config_key] && JSON.parse(localStorage[this.grid_config_key]).map((data:any) => (
    //  console.log(data.label)
     //               ))}
    return !this.state.gridOptions ? '' : (
       <>
          {/* The Modal */}
          <div id="sendEmailModal" className="modal">
            {/* Modal content */}
            <div className="modal-content">
              <div className="modal-header">
                <form id="frmSendMail" style={{width:"100%"}} >
                  <span className="close" onClick={() =>{this.hideModal()}}>×</span>
                  <div style={{textAlign: 'center'}}>Wysyłanie wiadomości e-mail</div>
                  <div style={{float: 'left', width: 100, textAlign: 'right'}}>Do: </div><div style={{float: 'left', marginLeft: 20, width: '90%', color: '#000!important'}}><input type="text" style={{width: '90%'}} name="mail_recipient" id="mail_recipient" /></div>
                  <div style={{clear: 'both'}} />
                  <div style={{float: 'left', width: 100, textAlign: 'right'}}>Temat:</div><div style={{float: 'left', marginLeft: 20, width: '90%', color: '#000!important'}}><input style={{marginTop: 5, width: '90%'}} type="text" name="mail_subject" id="mail_subject" /></div>
                  <div style={{clear: 'both'}} />
                </form></div>
                <div style={{float: 'left', width: 100, textAlign: 'right'}}>Treść: </div><div style={{float: 'left', marginLeft: 20, width: '90%', color: '#000!important'}}></div>  
              <div className="modal-body">
              
              <textarea style={{height: 500, width:'100%'}} id="tinymce1"></textarea>
              
               
              </div>
              <div className="modal-footer">
                <input  onChange={this.imageChange} type="file" id="files" name="files[]" multiple={true} />
                <button type="button" data-content="remove" className="btn btn-default" data-dismiss="modal" onClick={() => {this.hideModal()}}>Anuluj</button>
                <button type="button" data-content="remove" className="btn btn-primary" id="edtUserInGroupsBtn" onClick={(e) =>{this.sendMailSubmit(e)}}>Wyślij</button>
              </div>
            </div>
          </div>


          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              <FormControlLabel id="lblautoedit" style={{marginLeft:20}} control={<Switch id="incognito_switch" checked={this.state.incognito} onChange={(_, data) => {this.setState((state: State, props: BasicGridProps) => ({
                                                                                      ...state,
                                                                                      incognito: data,
                                                                                    }));
                                                                                    localStorage.removeItem(this.incognitoSearch_key)
                                                                                    }}  />} label={<><i className="fas fa-user-secret" placeholder='Incognito'/></>} />

              <TextField id="input_save_grid_config" onKeyDown={handleSaveConfigKeyDown.bind(this)} size="small" style={{width:'200px'}} label="Zapisz konfigurację" variant="outlined" />
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>
            <ContractorTableExportCSV
  grid={this.reactGrid}
  fileName="ExportedContractors"
  wscols={this.wscolsall}
  own_contractor_groups={this.own_contractor_groups}
/> 
            <EmailExportCSV
  grid={this.reactGrid}
  fileName="ExportedEmails"
  wscols={this.wscols}
  own_contractor_groups={this.own_contractor_groups}
/>
<PhoneExportCSV
  grid={this.reactGrid}
  fileName="ExportedPhoneNumbers"
  wscols={this.wscols}
  own_contractor_groups={this.own_contractor_groups}
/>
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.setCoresspondenceAddresses()}
              >
                <Tooltip title="Uzupełnij adresy korespondencyjne">
                <i className="fas fa fa-address-book nav-icon" />
                </Tooltip>
            </button>

    

            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              //onClick={() => this.openCompositeModal('edit')}
              >
                <Tooltip title="Usuń">
                <i className="fas fa fa-trash nav-icon" />
                </Tooltip>
            </button>

            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.toArchive()}
              >
                <Tooltip title="Do archiwum">
                <i className="fas fa  fa-archive nav-icon" />
                </Tooltip>
            </button>

            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={this.sendMails.bind(this)}
              >
                <Tooltip title="Mail">
                <i className="fas fa fa-at nav-icon" />
                </Tooltip>
            </button>


            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.printEnvelope()}
              >
                <Tooltip title="Koperty">
                <i className="fas fa fa-envelope nav-icon" />
                </Tooltip>
            </button>
              
            </div><div className='gridRightSubMenu'>
            <FormControl  style={{width:'200px'}}>
              <InputLabel id="select-grid-configuration">Wybierz konfigurację</InputLabel>
              <Select
                labelId="select-grid-configuration-label"
                id="select-grid-configuration-select"
                value={this.state.configuration_state}
                label="Konfiguracja"
                size="small"
                
                onChange={(event, child) => {this.handleChangeGridConfig(event, child)}}
              >
                 
                <MenuItem key={'Domyślna'} value={'Domyślna'}>                
                        <ListItemText primary={'Domyślna'} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                    </MenuItem>
                 {localStorage[this.grid_config_key] && JSON.parse(localStorage[this.grid_config_key]).map((data) => (
                    <MenuItem key={data.label} value={data.label}>               
                        <ListItemText  primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                    </MenuItem>
                                  ))}
              </Select>
             
            </FormControl>

            <Button onClick={() => this.clearCurrentConfiguration()} variant="contained" href="#contained-buttons">
              
              <ClearIcon/>
            </Button>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ust. domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          
          <SlickgridReact gridId="contractor-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }

  clearCurrentConfiguration = () => {
    var curr_config = localStorage.getItem(this.grid_currentconfig_key)
    var allEntries = localStorage.getItem(this.grid_config_key) ? JSON.parse(localStorage.getItem(this.grid_config_key)) : [];
    if (curr_config!='Domyślna'){
      localStorage.removeItem(this.grid_currentconfig_key)
      
      allEntries = allEntries.map((element) => element.label!=curr_config ? {...element} : [] ) 
      localStorage.setItem(this.grid_config_key, JSON.stringify(allEntries))  
      window.location.reload()
    }
 
     
  }
}

export default withTranslation()(Contractor);

